<template>
    <div>
        <v-carousel v-if="value !== null && typeof(value) !== 'undefined' && value.length > 0" height="auto" :show-arrows-on-hover="true">
            <v-carousel-item v-for="(fileId, i) in fileIds" :key="i">
                <file-image :value="fileId" :is-hover="true" />
            </v-carousel-item>
        </v-carousel>
        <v-card v-else>
            <v-card-title>
                <span class="headline">
                    No Photos
                </span>
            </v-card-title>
            <v-card-text>
                There are no photos to display
            </v-card-text>

            <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn @click="$emit('close')" color="quaternary" text>Ok</v-btn>
            </v-card-actions>
        </v-card>
        <v-dialog v-model="dialog" max-width="500px" :fullscreen="$vuetify.breakpoint.xsOnly">
            <template v-slot:activator="{ on }">
                <v-btn v-if="!readonly && !disabled" color="primary" dark v-on="on" @click="dialog = true">Upload File</v-btn>
            </template>

            <component :is="form" :filter="filter" @cancel="dialog = false" @open="dialog = true" @input="onInput" :key="key" />
        </v-dialog>
    </div>
</template>

<script>
    export default {
        props: [
            'value',
            'form',
            'filter',
            'readonly',
            'disabled'
        ],
        components: {
            fileImage: () => import('../components/FileImage'),
            fileUpload: () => import('../components/FileUpload')
        },
        data() {
            return {
                dialog: false,
                fileIds: [],
                key: 0
            }
        },
        methods: {
            onInput(value) {
                this.dialog = false;
                this.fileIds.push(value.fileId);
                this.$emit('input', this.fileIds);
                this.key++;
            }
        },
        watch: {
            value: {
                immediate: true,
                handler() {
                    this.fileIds = this.value === null ? [] : this.value;
                }
            }
        }
    };
</script>
